export const TOGGLE_DISPLAY = "@browser-display/TOGGLE_DISPLAY";
export const DISPLAY_HTML = "@browser-display/DISPLAY_HTML";
export const CLEAR_BROWSER = "@browser-display/CLEAR_BROWSER";